import styled, {keyframes, css} from 'styled-components';
import { assetPath } from '../../../utils/web-helper';
import MathCartImage from '~images/onboarding/math-cart.svg';
import ElaCartImage from '~images/onboarding/ela-cart.svg';
import {curiousBlue, lightPurple, deepCoveDark, white, royal, CornflowerBlue, indigo, Melrose} from '../../loggedout/shared-styles/Colors'
import FontGraphie from '../../loggedout/shared-styles/graphieFont';
import { device } from '../../../utils/responsive_utilities';

export const LearningPathRailAnimation = keyframes`
  0% {
    opacity: 1;
    transform: translate(0, -50%);
  }
  100% {
    opacity: 0;
    transform: translate(-144rem, -50%);
  }
`;

export const ScrollToView = (scrollAmount,isPortrait=false) => keyframes`
  0% {
    transform: translate(0, ${isPortrait ? '0' : '-50%'});
  }
  50% {
    transform: translate(${isPortrait ? 0 : -scrollAmount+'px'}, ${isPortrait ? -scrollAmount+'px' : '-50%'});
  }
  100% {
    transform: translate(0, ${isPortrait ? '0' : '-50%'});
  }
`;
export const CapsuleAnimation = (category, rowWise, animationYOffset, pausePosition) => keyframes`
  0% {
    opacity: 0;
    transform: translate(${category==='p' || rowWise ? '-50%' : 0}, ${rowWise ? -animationYOffset + 'px' : '9rem'});
  }
  40%{
    opacity: 1;    
    transform: translate(${category==='p' || rowWise ? '-50%' : 0}, ${rowWise && category == 'b' ? -(animationYOffset - pausePosition)+'px' : (rowWise ? -animationYOffset + 'px' : '9rem')});
  }

  70%{
    opacity: 1;
    transform: translate(${category==='p' || rowWise ? '-50%' : 0}, ${rowWise && category == 'b' ? -(animationYOffset - pausePosition)+'px' : (rowWise ? -animationYOffset + 'px' : '9rem')});
  }

  100% {
    opacity: 1;
    transform: translate(${category==='p' || rowWise ? '-50%' : 0}, 0);
  }
`;

export const RemoveCapsule = (category, rowWise) => keyframes`
  0% {
    opacity: 1;
    transform: translate(${category==='p' || rowWise ? '-50%' : 0}, 0);
  }
  100% {
    opacity: 0;
    transform: translate(${category==='p' || rowWise ? '-50%' : 0}, -2.0rem);
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: ${props=>(props.widthFixed || (!props.rowWise && props.scrollAmount)) ? '144rem' : '100%'};
  max-width: ${props=> !props.rowWise && props.scrollAmount ? '144rem' : '100%'};
  ${props=>props.widthFixed ? css`overflow-x: auto` : null};
  height: 41rem;
  margin: 2rem auto 0;
  position: relative;
  top: 37%;
  transform: translate(0, -50%);
  scrollbar-width: none;
  ${props=>props.startTrain ?
    css`
      animation: ${LearningPathRailAnimation} 2s ease-out forwards;
    `:
    props.scrollAmount ? 
      css` 
        animation: ${ScrollToView(props.scrollAmount, props.rowWise)} 2s ${props => props.rowWise ? '2s' : '1s'} ease-in-out;
      `: 
        null};
  &::-webkit-scrollbar {
    display: none;
  }
  @media ${device.PhoneTabletLandscape}{
    height: 22rem;
    margin: 1rem auto 0;
    overflow-x: auto;
    overflow-y: ${props=> props.buildLearningPath ? 'hidden' : 'auto'};
    width: ${props=>(props.widthFixed || (!props.rowWise && props.scrollAmount)) ? '150rem' : '100%'};
    max-width: ${props=> !props.rowWise && props.scrollAmount ? '150rem' : '100%'};
  }

  ${props => props.rowWise ? css`
    height:  ${(props.scrollAmount ? (props.isMobilePortrait ? '160rem' : '190rem') : (props.buildLearningPath ? 'calc(100% - 15.3rem)' : (props.isMobilePortrait ? css`calc(100% - 17.5rem)` : css`calc(100% - 25rem)` ) )) };
    overflow-y: auto;
    overflow-x: ${props => props.buildLearningPath ? 'hidden' : 'auto'};
    top: unset;
    transform: unset;

    ${props.isMobilePortrait ? 
      css`width: 37.5rem;margin:3.5rem auto 1rem;` : 
      (props.isTabletPortrait ? css`width:76.8rem;margin:${props.buildLearningPath ? '2rem' : '5rem'} auto 1rem;` : 
      '')}
  ` : ""}  
`;

export const CapsuleLabel = styled.button`
  max-width: 21rem;
  width: 18rem;
  align-self: center;
  font: normal 700 2rem/2.4rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  color: ${white};
  background: ${props=>props.category==='b'? curiousBlue: lightPurple};
  box-shadow: 0 0.4rem 0 rgba(9, 10, 74, 0.2);
  border-radius: 3.2rem;
  outline: none;
  border: 0;
  height: 3.4rem;
  box-sizing: border-box;
  pointer-events: none;
  align-self: ${props=>props.end || 'center'};
  transform: rotate(${props=> props.rowWise ? 4 : props.category==='p' ? -4 : 4}deg);
  ${props => props.rowWise ? css`margin:auto;`: ""}

  @media ${device.PhoneTabletLandscape}{
    width: 10rem;
    height: 2.5rem;
    font: normal 700 1.1rem/1.7rem 'Graphie','Helvetica','Arial','sans-serif';
  }
`;

export const StartLearningPath = styled.a`
  display: block;
  width: 40.9rem;
  position: fixed;
  bottom: 5rem;
  color: ${deepCoveDark};
  border-radius: 10rem;
  background: ${white};
  padding: 1.3rem 0;
  margin: 0 auto;
  left: 50%;
  z-index: 2;
  ${FontGraphie(2.4,1,6)}

  @media ${device.IpadProLargeP}{
    bottom: 15rem;
  }
  @media ${device.TabletLandscape}{
    padding: 2rem 0;
  }

  @media ${device.Tablet}{
    bottom: 6.4rem;
    width: 41.9rem;
    padding: 1.8rem 3.7rem;
    box-sizing: border-box;
  }

  @media ${device.PhoneTabletLandscape}{
    width: 21rem;
    bottom: 2rem;
    padding: 1.2rem 0;
    ${FontGraphie(1.6,1,6)}
  }

  @media ${device.Phone}{
    width: 34.3rem;
    padding: 1.8rem 8.8rem;
    box-sizing: border-box;
    ${FontGraphie(2,1,6)}
    bottom: 2.4rem;
  }

  ${(props) => typeof(props.ctaTransition) !== 'undefined' && !props.ctaTransition ? css`
    transform: translate(-50%, 20rem);
    opacity: 0;
    transition: all 1s;
  ` : null
  }
  ${(props) => props.ctaTransition ? css`
    transform: translate(-50%, 0);
    opacity: 1;
    transition: all 1s;
    ` : null
  }
`;
export const LearningRopeWrapper = styled.div`
  position: absolute;
  top: ${props => props.rowWise ? '0' : '7rem'};
  left: 0;
  width: 144rem;
  height: ${props => props.rowWise ? 'auto' : '30rem'};

  @media ${device.Tablet}{
    width: ${props => props.rowWise ? '45rem' : '144rem'};
    left: ${props => props.rowWise ? 'unset' : '0'};
  }
  @media ${device.Phone}{
    width: 100%;
  }
  @media ${device.PhoneTabletLandscape}{
    top: -4rem;
  }
`;
export const CartAnimation = keyframes`
  0% {
    transform: scale(0.1);
  }
  50% {
    transform: scale(1.3);
  }
  100% {
    transform: scale(1);
  }
`;
export const CartWrapper = styled.div`
  position: absolute;
  top: 7rem;
  left: -5rem;
  width: 29rem;
  height: 22rem;
  transform: scale(0);
  background: url(${props=>assetPath(props.subject==='math'? MathCartImage : ElaCartImage)}) top left/100% 100% no-repeat;
  animation: ${CartAnimation} 900ms ease-out 400ms forwards;
  @media ${device.Tablet}{
    width: 19rem;
    height: 22.4rem;
    top: 4rem;
    left: 18rem;
  }
  @media ${device.PhoneTabletLandscape}{
    width: 12rem;
    height: 18.4rem;
    top: 1rem;
    left: 4rem;
  }
  @media ${device.Phone}{
    width: 15.6rem;
    height: 18.4rem;
    top: 3rem;
    left: 3rem;
  }
`;

export const NextGradeWrapper = styled.div`
  position: absolute;
  left: 125.2rem;
  width: 20rem;
  top: 12rem;
  @media ${device.Tablet}{
    left: 38.5rem;
    top: 150rem;
  }
  @media ${device.PhoneTabletLandscape}{
    left: 127.2rem;
    width: 14rem;
    top: 5rem;
  }
  @media ${device.Phone}{
    left: unset;
    right: 2rem;
    top: 120rem;
  }
`;

export const SectionHeading = styled.h4`
  color: ${Melrose};
  align-self: ${props=>props.end || 'flex-end'};
  padding: 1rem 0 0;
  font: normal 600 1.2rem/1.6rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  ${props => props.rowWise ? css`margin:auto;`: ""}
  /* ${props => props.isMobilePortrait ? css`font: normal 600 1.4rem/2rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';` : ''} */

  @media ${device.PhoneTabletLandscape}{
    padding: 0.5rem 0 0;
    font: normal 600 1.0rem/1.2rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
    white-space: nowrap;
  }
`;

export const CategorySection = styled.div`
  position: absolute;
  left: ${props=>props.getInCenter || props.sideH};
  top: ${props =>props.sideV};
  transform: translate(${props=>props.category==='p' || props.rowWise ? '-50%' : 0}, 0);
  display: flex;
  flex-direction: column;
  opacity:${props=>props.removeCapsule ? 1: 0};
  animation: ${props=>props.removeCapsule ? RemoveCapsule(props.category, props.rowWise) : CapsuleAnimation(props.category, props.rowWise, props.animationYOffset, props.pausePosition)} ${props=> props.rowWise ? '2s' : '800ms'} ${props => props.delay && !props.removeCapsule ? props.delay + 's' : '200ms'}  ease-out forwards;
  ${props => props.rowWise ? 'width: 80%;left:50%;' : ''}
  @media ${device.PhoneTabletLandscape}{
    margin-top: 0.3rem;
  }
`;
export const LearningPathCTAWrapper = styled.div`
  display: flex;
  width: 60rem;
  font: normal 600 2.4rem/3rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  margin: 0 auto;
  justify-content: space-around;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 2.5rem;
  ${(props) => !props.ctaTransition ? css`
    transform: translate(-50%, 20rem);
    opacity: 0;
    transition: all 1s ease-out;
  ` : null
  }
  ${(props) => props.ctaTransition ? css`
    transform: translate(-50%, 0);
    opacity: 1;
    transition: all 1s ease-out ${props=> props.rowWise ? '6.5s' : '2.2s'};
    ` : null
  }
  
  @media ${device.Tablet}{
    z-index: 2;
    bottom: 6.4rem;
  }

  @media ${device.PhoneTabletLandscape}{
    font: normal 600 1.6rem/2rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
    width: 52rem;
    bottom: 2.4rem;
  }
  @media ${device.Phone}{
    font: normal 600 2rem/1.8rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
    flex-direction: column-reverse;
    width: 100%;
    height: 14rem;
    transform: unset;
    left: unset;
    align-items: center;
    z-index: 2;
    bottom: 2.4rem;
  }
`;

export const LearningPathCTA = styled.a`
  width: 28.3rem;
  border: ${props=>props.ctaType==="start-play" ? 0 : '0.1rem'} solid ${indigo};
  border-radius: 4rem;
  padding: 1.6rem 0;
  color: ${props=>props.ctaType==="start-play" ? royal : CornflowerBlue};
  background-color: ${props=>props.ctaColor ? props.ctaColor : ''};

  @media ${device.PhoneTabletLandscape}{
    width: 19.5rem;
    padding: 1rem 2.4rem;
  }
  @media ${device.Phone}{
    width: 34.3rem;
    padding: 2rem 0;
  }
`;
export const TextGradeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
export const NextGradeText = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 13rem;
  top: 8rem;
  height: 4.7rem;
  color: ${royal};
  opacity: 0;
  z-index: 1;
  font: normal bold 1.6rem/2rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
  animation: ${TextGradeAnimation} 300ms ease-out 1s forwards;

  @media ${device.PhoneTabletLandscape}{
    font: normal bold 1rem/1.6rem 'Graphie', 'Helvetica', 'Arial', 'sans-serif';
    top: 6rem;
  }
`;

export const CurrentGrade = styled.span`
  position: absolute;
  left: 6.7rem;
  top: 2.9rem;
  transform: rotate(-29deg);
  font: normal bold 1.6rem/2rem 'Graphie','Helvetica','Arial','sans-serif';
  color: ${royal};
  width: 11.3rem;
  height: 6rem;

  @media ${device.Tablet}{
    left: 1.2rem;
    top: 2.9rem;
  }
  @media ${device.PhoneTabletLandscape}{
    font: normal bold 1.1rem/1.7rem 'Graphie','Helvetica','Arial','sans-serif';
    left: 0.5rem;
    top: 3rem;
    width: 8rem;
  }
  @media ${device.Phone}{
    font: normal bold 1.3rem/1.7rem 'Graphie','Helvetica','Arial','sans-serif';
    left: 0.5rem;
    top: 1.9rem;
    width: 10.3rem;
  }
`;
export const CurrentGradeText = styled.i`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
  width: 100%;
  opacity: 1;
  @media ${device.Tablet}, ${device.Phone}{
    opacity: 0;
    animation: ${TextGradeAnimation} 300ms ease-out 3s forwards;
  }
`;